import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionSignMultipleDocsPayload } from 'api/actions/revision-sign-multiple-docs/revision-sign-multiple-docs-payload';
import { RevisionSignMultipleDocsPathParameters } from 'api/actions/revision-sign-multiple-docs/revision-sign-multiple-docs-path-parameters';
import { RevisionSignMultipleDocsResponse } from 'api/actions/revision-sign-multiple-docs/revision-sign-multiple-docs-response';

type RevisionSignMultipleDocsQueryParameters = Record<string, any>;

/**
 * The path of the RevisionSignMultipleDocs action.
 */
export const revisionSignMultipleDocsActionPath = new SweetPath<keyof RevisionSignMultipleDocsPathParameters>(
  '/api/revision/sign-multiple-docs',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionSignMultipleDocs actions.
 */
export default function createRevisionSignMultipleDocsAction(axios: AxiosInstance) {
  return function revisionSignMultipleDocsAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: RevisionSignMultipleDocsQueryParameters;
    payload: RevisionSignMultipleDocsPayload;
  }) {
    const path = revisionSignMultipleDocsActionPath.original;

    return axios.request<RevisionSignMultipleDocsResponse, RevisionSignMultipleDocsResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
